import React, { useState } from "react";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    ContentActionsRow,
    BtnIcon,
    TabsNav,
    Tab
} from "../../components/SharedPageStyles";
import { SECTIONS } from "../../constants/sections";

import IndicesTab from "./tabs/IndicesTab";
import CommoditiesTab from "./tabs/CommoditiesTab";
import ForexTab from "./tabs/ForexTab";
import CryptoTab from "./tabs/CryptoTab";

import { useMarketOverviewData } from "../../context/MarketOverviewContext";
import { FiAward } from "react-icons/fi";
import AssetRankingsModal from "./AssetRankingsModal";
import ExportButton from "../../components/ExportButton";

const MarketOverview = () => {
    const [activeTab, setActiveTab] = useState(SECTIONS["market-overview"].tabs[0].key);
    const [isRankingsOpen, setIsRankingsOpen] = useState(false);
    const { resetData, rows, isLoading } = useMarketOverviewData();

    const renderTabContent = () => {
        switch (activeTab) {
            case "indices": return <IndicesTab />;
            case "commodities": return <CommoditiesTab />;
            case "forex": return <ForexTab />;
            case "crypto": return <CryptoTab />;
            default: return <CommoditiesTab />;
        }
    };

    return (
        <>
            <ContentHeader>
                <ContentTitleBlock>
                    <Chip>Market Overview</Chip>
                    <Subtitle><em>Real-time market sentiment and key movers.</em></Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow>
                <BtnIcon
                    aria-label="Ranking"
                    onClick={() => setIsRankingsOpen(true)}
                    title="Ranking"
                >
                    <FiAward />
                </BtnIcon>
                <BtnIcon
                    aria-label="Refresh data"
                    onClick={resetData}
                    title="Refresh data"
                    disabled={isLoading}
                    $spinning={isLoading}
                >
                    ⟳
                </BtnIcon>
                <ExportButton data={rows} filename="market_overview" />
            </ContentActionsRow>

            <TabsNav>
                {SECTIONS["market-overview"].tabs.map(tab => (
                    <Tab
                        key={tab.key}
                        active={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </Tab>
                ))}
            </TabsNav>

            {renderTabContent()}

            <AssetRankingsModal
                open={isRankingsOpen}
                onClose={() => setIsRankingsOpen(false)}
                rows={rows}
            />
        </>
    );
};

export default MarketOverview;
